/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `AG` - AI Gravimetric
* `FL` - Flake Lab Report
* `MG` - Manual Gravimetric
 */
export type SampleType = typeof SampleType[keyof typeof SampleType];


export const SampleType = {
  AG: 'AG',
  FL: 'FL',
  MG: 'MG',
} as const;
